
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"11","viewBox":"0 0 17 16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M.5 0h15.25v15.25H.5z"}}),_c('path',{attrs:{"fill":"#6D7587","fill-rule":"nonzero","d":"M15.5 12.913V15H.5v-2.087h15zM9.042 0v7.09l2.703-2.692 1.471 1.472-5.217 5.217L2.78 5.87l1.472-1.472L6.955 7.09V0h2.087z"}})])])
          )
        }
      }
    